import script from "./ImageViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageViewer.vue?vue&type=script&setup=true&lang=ts"

import "./ImageViewer.vue?vue&type=style&index=0&id=132c5b9f&scoped=true&lang=css"
import "./ImageViewer.vue?vue&type=style&index=1&id=132c5b9f&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-132c5b9f"]])

export default __exports__